import React from "react";
import TabsNavigator from "components/TabsNavigator";
import PageShell from "components/bento/PageShell";
import StationList from "./StationList";
import RouteList from "scenes/routes/RouteList";

const StationsAndRoutes = () => {
  const tabItems = [
    { text: "Stations", component: <StationList />, slug: "stations/list" },
    { text: "Routes", component: <RouteList />, slug: "stations/routes" },
  ];

  return (
    <PageShell title="Stations & Routes">
      <TabsNavigator tabItems={tabItems} pageSlug="stations" />
    </PageShell>
  );
};

export default StationsAndRoutes;
